export default __webpack_public_path__ + "static/media/pipa.e936a68e.png";